/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { ShipmentResultFragmentDoc } from '../../../../../../../../shippers/components/ShipperFacilities/ListTrailerPoolsModal/ShipmentAutosuggest/graphql/ShipmentResultFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type ISearchShipmentsQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']
  after?: Types.Maybe<Types.Scalars['String']>
  before?: Types.Maybe<Types.Scalars['String']>
  first?: Types.Maybe<Types.Scalars['Int']>
  last?: Types.Maybe<Types.Scalars['Int']>
  sortBy?: Types.Maybe<Types.Scalars['String']>
  sortDirection?: Types.Maybe<Types.ISortOrderEnum>
  ids?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  state?: Types.Maybe<Array<Types.IShipmentStates> | Types.IShipmentStates>
  carrierApplicationIds?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  shipperApplicationIds?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  pickupCity?: Types.Maybe<Types.Scalars['String']>
  pickupDates?: Types.Maybe<Array<Types.Scalars['ISO8601Date']> | Types.Scalars['ISO8601Date']>
  pickupStateCode?: Types.Maybe<Types.Scalars['String']>
  pickupMiles?: Types.Maybe<Types.Scalars['Int']>
  deliveryCity?: Types.Maybe<Types.Scalars['String']>
  deliveryDates?: Types.Maybe<Array<Types.Scalars['ISO8601Date']> | Types.Scalars['ISO8601Date']>
  deliveryStateCode?: Types.Maybe<Types.Scalars['String']>
  deliveryMiles?: Types.Maybe<Types.Scalars['Int']>
  shipperFacilityUuids?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  carrierAssignedBefore?: Types.Maybe<Types.Scalars['ISO8601DateTime']>
  carrierAssignedAfter?: Types.Maybe<Types.Scalars['ISO8601DateTime']>
  dropTrailer?: Types.Maybe<Types.Scalars['Boolean']>
  hasClaims?: Types.Maybe<Types.Scalars['Boolean']>
  hasTrailer?: Types.Maybe<Types.Scalars['Boolean']>
  managedByTransfix?: Types.Maybe<Types.Scalars['Boolean']>
  noAppointmentTime?: Types.Maybe<Types.Scalars['Boolean']>
  unconfirmedAppointment?: Types.Maybe<Types.Scalars['Boolean']>
  sameDaySpot?: Types.Maybe<Types.Scalars['Boolean']>
  shipperRateId?: Types.Maybe<Types.Scalars['ID']>
}>

export type ISearchShipmentsQuery = { __typename?: 'Query' } & {
  shipments: { __typename?: 'ShipmentConnection' } & {
    nodes?: Types.Maybe<
      Array<
        Types.Maybe<
          { __typename?: 'Shipment' } & Pick<Types.IShipment, 'id'> & {
              firstPickup: { __typename?: 'ShipmentStop' } & Pick<
                Types.IShipmentStop,
                'id' | 'city' | 'stateCode'
              >
              lastDelivery: { __typename?: 'ShipmentStop' } & Pick<
                Types.IShipmentStop,
                'id' | 'city' | 'stateCode'
              >
            }
        >
      >
    >
  }
}

export const SearchShipmentsDocument = gql`
  query SearchShipments(
    $searchTerm: String!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sortBy: String
    $sortDirection: SortOrderEnum
    $ids: [ID!]
    $state: [ShipmentStates!]
    $carrierApplicationIds: [ID!]
    $shipperApplicationIds: [ID!]
    $pickupCity: String
    $pickupDates: [ISO8601Date!]
    $pickupStateCode: String
    $pickupMiles: Int
    $deliveryCity: String
    $deliveryDates: [ISO8601Date!]
    $deliveryStateCode: String
    $deliveryMiles: Int
    $shipperFacilityUuids: [ID!]
    $carrierAssignedBefore: ISO8601DateTime
    $carrierAssignedAfter: ISO8601DateTime
    $dropTrailer: Boolean
    $hasClaims: Boolean
    $hasTrailer: Boolean
    $managedByTransfix: Boolean
    $noAppointmentTime: Boolean
    $unconfirmedAppointment: Boolean
    $sameDaySpot: Boolean
    $shipperRateId: ID
  ) {
    shipments(
      query: $searchTerm
      after: $after
      before: $before
      first: $first
      last: $last
      sortBy: $sortBy
      sortDirection: $sortDirection
      ids: $ids
      state: $state
      carrierApplicationIds: $carrierApplicationIds
      shipperApplicationIds: $shipperApplicationIds
      pickupCity: $pickupCity
      pickupDates: $pickupDates
      pickupStateCode: $pickupStateCode
      pickupMiles: $pickupMiles
      deliveryCity: $deliveryCity
      deliveryDates: $deliveryDates
      deliveryStateCode: $deliveryStateCode
      deliveryMiles: $deliveryMiles
      shipperFacilityUuids: $shipperFacilityUuids
      carrierAssignedBefore: $carrierAssignedBefore
      carrierAssignedAfter: $carrierAssignedAfter
      dropTrailer: $dropTrailer
      hasClaims: $hasClaims
      hasTrailer: $hasTrailer
      managedByTransfix: $managedByTransfix
      noAppointmentTime: $noAppointmentTime
      unconfirmedAppointment: $unconfirmedAppointment
      sameDaySpot: $sameDaySpot
      shipperRateId: $shipperRateId
    ) {
      nodes {
        ...ShipmentResult
      }
    }
  }
  ${ShipmentResultFragmentDoc}
`

/**
 * __useSearchShipmentsQuery__
 *
 * To run a query within a React component, call `useSearchShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchShipmentsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      ids: // value for 'ids'
 *      state: // value for 'state'
 *      carrierApplicationIds: // value for 'carrierApplicationIds'
 *      shipperApplicationIds: // value for 'shipperApplicationIds'
 *      pickupCity: // value for 'pickupCity'
 *      pickupDates: // value for 'pickupDates'
 *      pickupStateCode: // value for 'pickupStateCode'
 *      pickupMiles: // value for 'pickupMiles'
 *      deliveryCity: // value for 'deliveryCity'
 *      deliveryDates: // value for 'deliveryDates'
 *      deliveryStateCode: // value for 'deliveryStateCode'
 *      deliveryMiles: // value for 'deliveryMiles'
 *      shipperFacilityUuids: // value for 'shipperFacilityUuids'
 *      carrierAssignedBefore: // value for 'carrierAssignedBefore'
 *      carrierAssignedAfter: // value for 'carrierAssignedAfter'
 *      dropTrailer: // value for 'dropTrailer'
 *      hasClaims: // value for 'hasClaims'
 *      hasTrailer: // value for 'hasTrailer'
 *      managedByTransfix: // value for 'managedByTransfix'
 *      noAppointmentTime: // value for 'noAppointmentTime'
 *      unconfirmedAppointment: // value for 'unconfirmedAppointment'
 *      sameDaySpot: // value for 'sameDaySpot'
 *      shipperRateId: // value for 'shipperRateId'
 *   },
 * });
 */
export function useSearchShipmentsQuery(
  baseOptions: Apollo.QueryHookOptions<ISearchShipmentsQuery, ISearchShipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISearchShipmentsQuery, ISearchShipmentsQueryVariables>(
    SearchShipmentsDocument,
    options
  )
}
export function useSearchShipmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISearchShipmentsQuery, ISearchShipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISearchShipmentsQuery, ISearchShipmentsQueryVariables>(
    SearchShipmentsDocument,
    options
  )
}
export type SearchShipmentsQueryHookResult = ReturnType<typeof useSearchShipmentsQuery>
export type SearchShipmentsLazyQueryHookResult = ReturnType<typeof useSearchShipmentsLazyQuery>
export type SearchShipmentsQueryResult = Apollo.QueryResult<
  ISearchShipmentsQuery,
  ISearchShipmentsQueryVariables
>
